import {authenticationApi} from '../api/authenticationApi';

export function authHeader() {
	// return authorization header with jwt token
	const currentUser = authenticationService.currentUserValue;
	if (currentUser && currentUser.token) {
		return {
			Authorization: `Bearer ${currentUser.token}`
		};
	} else {
		return {};
	}
}

export function isAdmin(user) {
	if (!isLoggedIn(user)) return false;
	const role = user && user.role;
	return role === 'Admin' || role === 'Support';
}

export function isLoggedIn(user) {
	return !!(user && user.email !== undefined);
}

function csrfToken(doc) {
	const meta = doc && doc.querySelector && doc.querySelector('[name="csrf-token"]');
	const content = meta && meta.getAttribute && meta.getAttribute('content');
	return typeof content === 'string' ? content : null;
}

export function passCsrfToken(doc, axiosInstance) {
	const token = csrfToken(doc);
	if (token && axiosInstance && axiosInstance.defaults && axiosInstance.defaults.headers) {
		axiosInstance.defaults.headers.common['X-CSRF-TOKEN'] = token;
	} else if (axiosInstance && axiosInstance.defaults && axiosInstance.defaults.headers && axiosInstance.defaults.headers.common) {
		delete axiosInstance.defaults.headers.common['X-CSRF-TOKEN'];
	}
}

// Set to true while logout is in progress; prevents late getUserDetails() from repopulating Redux
let loggingOut = false;

export function setLoggingOut(value) {
	loggingOut = value;
}

export function isLoggingOut() {
	return loggingOut;
}

export function logout() {
	// Auth is cookie-only; clear any stale legacy keys if present
	localStorage.removeItem('token');
	localStorage.removeItem('isLoggedIn');
}
